import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaLock, FaLockOpen, FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import { NS, U3121ROLES } from "../../../U3121";
import type { U3121SubProject } from "../../../U3121Service";

interface U3121SubProjectFormToolBarProps {
  formStateHandlers: U2000FormStateHandlers<U3121SubProject> & {
    addNewSubProject: () => void;
    modifySubProject: () => void;
    deleteSubProject: () => void;
    changeStatusSubProject: () => void | Promise<void>;
  };
}

export const U3121SubProjectFormToolBar: React.FC<U3121SubProjectFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();
  const sub = formStateHandlers.getData();
  const isActive = sub?.subProjectStatus === true;
  const changeStatusLabel = isActive ? t("btnClose", { ns: NS }) : t("btnReopen", { ns: NS });

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U3121ROLES.ADD),
      handleClick: () => formStateHandlers.addNewSubProject(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U3121ROLES.EDIT),
      handleClick: () => formStateHandlers.modifySubProject(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U3121ROLES.DELETE),
      handleClick: () => formStateHandlers.deleteSubProject(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
    {
      key: "changeStatus",
      label: changeStatusLabel,
      hasRole: hasRole(U3121ROLES.EDIT),
      handleClick: () => formStateHandlers.changeStatusSubProject(),
      disabled: formState === U2000FormStateEnumState.EDIT || !sub?.id,
      icon: isActive ? FaLock : FaLockOpen,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
